var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdoutShapeImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 482,
    height: 484,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6C6C",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M0 1h481v481H0V1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6C6C",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M240.001 1c98.857 0 179 80.183 179 179.094 0 98.91-80.143 179.094-179 179.094C141.141 359.188 61 279.004 61 180.094 61 81.183 141.141 1 240.001 1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6C6C",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M240.001 62.407c98.857 0 179 80.182 179 179.094 0 98.909-80.143 179.092-179 179.092C141.141 420.593 61 340.41 61 241.501c0-98.912 80.141-179.094 179.001-179.094z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C6C6C",
    fillOpacity: 0,
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeWidth: 2,
    d: "M240.001 123.813c98.857 0 179 80.183 179 179.093 0 98.911-80.143 179.093-179 179.093C141.141 481.999 61 401.817 61 302.906c0-98.91 80.141-179.093 179.001-179.093z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdoutShapeImg);
export default __webpack_public_path__ + "static/media/adout-shape-img.8f1fd071369f6e0d83b0bd8cba054b72.svg";
export { ForwardRef as ReactComponent };